var enableGeolocEveryXSeconds = 3*3600;//3h
var force_geo_code = false; 
/*var ayaq_render_visiblesections = [];*/
var geo_country_code = "FR";
var cartLasttimestampGeo = 0;
var debug = false;
//var studio_countries = "KR,JP,RU,GB,DE,UK,DK,SE,FI,NO"; dans theme

var countryConfig = {
  ch:{
    cur:"CHF",
    chgPrice:false
  },
  ru:{
    cur:"€",
    chgPrice:true
  }
};

function alertDbg(msg){
  if (debug) alert(msg);
}

//add reload url après done
function init(){
  studio_countries = isString(studio_countries)?studio_countries.toLowerCase().trim() : studio_countries;
  var thisU = window.location.search.substring(1),sURLVariables = thisU.split('&');
  for (var i=0; i<sURLVariables.length; i++) {
    var sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === "gl") {
      var val = sParameterName[1];
      if (!!val && isString(val)){
        if (studio_countries.includes(val.toLowerCase())){
          alertDbg("force : "+val);
          force_geo_code = val;
        }
        else{//reinit
          cartLasttimestampGeo = 0;//pour forcer relance
          force_geo_code = false;
        }
        window.location.href = "/";
      }
      else{
        enableGeolocEveryXSeconds = 3*3600;//3h
      }
    }
  }
}

function isString(value) {
    return typeof value === "string";
}

function addVisibilitySection(section_id, visible_only_countries, invisible_only_countries){
  ayaq_render_visiblesections = ayaq_render_visiblesections || [];
  ayaq_render_visiblesections[section_id] = {
    section_id : section_id,
    visible_only_countries : visible_only_countries, 
    invisible_only_countries : invisible_only_countries
  };
}

function renderVisibleSections(){
  studio_countries = isString(studio_countries)?studio_countries.toLowerCase().trim() : studio_countries;
  $( document ).ready(function() {
    // Keep the header flag aligned with the same detected country as other sections.
    document.querySelectorAll('[data-hide-flag-countries]').forEach(function(flag) {
      var excludedCountries = flag.dataset.hideFlagCountries.toLowerCase().split(',').map(function(code) {
        return code.trim();
      }).filter(Boolean);
      flag.hidden = excludedCountries.includes(geo_country_code.trim().toLowerCase());
    });
    for (var section_id in ayaq_render_visiblesections){
      var section_infos = ayaq_render_visiblesections[section_id];
      var visible_only_countries = section_infos["visible_only_countries"];
      visible_only_countries = isString(visible_only_countries)?visible_only_countries.toLowerCase().trim() : visible_only_countries;
      var invisible_only_countries = section_infos["invisible_only_countries"];
      invisible_only_countries = isString(invisible_only_countries)?invisible_only_countries.toLowerCase().trim() : invisible_only_countries;
      
      if (!!visible_only_countries && visible_only_countries=="studio"){
        visible_only_countries = studio_countries;
      }
      if (!!invisible_only_countries && invisible_only_countries=="studio"){
        invisible_only_countries = studio_countries;
      }      
      var visible = false;
      if (!!visible_only_countries && visible_only_countries.includes(geo_country_code)){
        visible = true;
      }
      else if (!!invisible_only_countries && !invisible_only_countries.includes(geo_country_code)){
        visible = true;
      }
      if (visible){
        $("#"+section_id).show();
      }

    }
  });
}

function gIfNotDone(cartTimestamp, currentColl, stopgeoloc){
  cartLasttimestampGeo = cartTimestamp;
  init();//change le cartLasttimestampGeo
  if (stopgeoloc) return;
  var nowTimeStamp = Math.floor(Date.now() / 1000);
  var diff = nowTimeStamp - cartLasttimestampGeo;
  var timeout = diff > enableGeolocEveryXSeconds;
  if (!!force_geo_code){
    alertDbg("no geoloc : force and put in cart... -----> "+ force_geo_code);
    putg("ayaq", "", force_geo_code);
    changeAllP(force_geo_code);
  }
  else if (timeout || !currentColl){//do it
    geo(function(code_iso_country){
      alertDbg("new geolocation (timeout)... -----> "+ code_iso_country);
      changeAllP(code_iso_country);
    });
  }
  else{//get it or do it
    jQuery.getJSON('/cart.js', function(cart) {
      var code_iso_country;
      if (!!cart.attributes) code_iso_country = cart.attributes.cc;
      if (!!force_geo_code) code_iso_country = force_geo_code;
      
      if (!code_iso_country){//not there, do it
        
        geo(function(code_iso_country){
          alertDbg("new geolocation... -----> "+ code_iso_country);
          changeAllP(code_iso_country);
        });
      }
      else{
        alertDbg("already done, getting it... "+code_iso_country);
        changeAllP(code_iso_country);
      }
    });
  }
}
var geo = function(callback){
  var collection = "ayaq"; 
  var css = "aHR0cHM6Ly9ldXJvcGUtd2VzdDYtYXlhcS0zNDQxMDkuY2xvdWRmdW5jdGlvbnMubmV0L2NzczI=";
  jQuery.ajax({
    type: 'GET',
    url: atob(css),//also secured server side{% comment %}'https://europe-west6-ayaq-295917.cloudfunctions.net/css',//also secured server side{% endcomment %}
    dataType: 'json',
    success: function(d) {
      var cssversion = d.cssversion;
      if (!cssversion && !!d.cssversion2) cssversion = d.cssversion2;
      var code_iso_country = "FR"; 
      if (!!d.country){
        code_iso_country = d.country;
        var count = code_iso_country.toLowerCase().trim();
        if (count == "ru") collection = "ayaqch"; /*collection = "ayaq" + count;*/
      }

      if (!!force_geo_code) code_iso_country = force_geo_code;
      
      putg(collection, cssversion, code_iso_country);
      callback(code_iso_country);
    },
    error: function(XMLHttpRequest, textStatus) {
      //result = "KO for unknown reason";
      putg();
      callback("FR");
    }
  });
}

function changeAllP(code_iso_country){
  //Show what needs to be shown
  geo_country_code = code_iso_country.toLowerCase();
  renderVisibleSections();
  
  //Change prices
  if (!!code_iso_country) code_iso_country = code_iso_country.toLowerCase();
  else return;
  //var count = coll.substring(4);//"", ch, ru ...
  if (!!countryConfig[code_iso_country]){//Change price
    var countryCfg = countryConfig[code_iso_country];
    var targetCurrency = countryCfg["cur"];
    var changePrice = countryCfg["chgPrice"];
    $( document ).ready(function() {
      if (changePrice){
        $(".prodprice").each( function(){
          var prodid = $(this).attr("prodid");
          var prodPrice = aP["prices"][prodid];
          if (!!prodPrice){
            var priceToDisp ='<span class="money">'+prodPrice+' '+targetCurrency+'</span>';
            $(this).html(priceToDisp);
          }
        });
      }
      else{
        $(".prodprice").each( function(){
          var prodid = $(this).attr("prodid");
          var prodPrice = aP["prices"][prodid];
          var priceToDisp = $(this).html().replace("€", targetCurrency);
          $(this).html(priceToDisp);
        });
      }
    });
  }
}
var putg = function(coll, cssversion, cc){
  coll = coll || "ayaq";
  cc = cc || "FR";
  
  var nowTimeStamp = Math.floor(Date.now() / 1000);
    $.post('/cart/update.js', {
      attributes: {
        'co': coll,
        'd': nowTimeStamp,
        'i':cssversion,
        'cc':cc
      }
    }).done(function( data ) {
    }).fail(function() {
    }).always(function() {
    });
  }
